import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SubscriptionSetupRequest, SubscriptionSetupResponse, SubscriptionStatusResponse } from '../../interfaces/stripe/stripe-interface';

@Injectable({
  providedIn: 'root',
})
export class StripeGatewayService {
  private urlPrefix: string = '/api/stripe';

  constructor(private httpClient: HttpClient) {}

  public setupSubscription(request: SubscriptionSetupRequest): Observable<SubscriptionSetupResponse> {
    const url: string = `${environment.api.url}${this.urlPrefix}/subscription/setup`;
    return this.httpClient.post<SubscriptionSetupResponse>(url, request);
  }

  public getSubscriptionStatus(): Observable<SubscriptionStatusResponse> {
    const url: string = `${environment.api.url}${this.urlPrefix}/subscription/status`;
    return this.httpClient.get<SubscriptionStatusResponse>(url);
  }

  public getPublishableKey(): Observable<{ publishableKey: string }> {
    const url: string = `${environment.api.url}${this.urlPrefix}/publishable-key`;
    return this.httpClient.get<{ publishableKey: string }>(url);
  }

  public getCustomerSession(): Observable<{ clientSecret: string }> {
    const url: string = `${environment.api.url}${this.urlPrefix}/customer-session`;
    return this.httpClient.get<{ clientSecret: string }>(url);
  }

  public createCustomerPortalSession(returnUrl: string): Observable<{ url: string }> {
    const url: string = `${environment.api.url}${this.urlPrefix}/customer-portal-session`;
    return this.httpClient.post<{ url: string }>(url, { returnUrl });
  }
}
